export default "__VITE_ASSET__VnHGy1VY__"